import type { AccountTab } from "./portal-navigation";

const groups: { title: string; tabs: AccountTab[] }[] = [
  {
    title: "Telephone service",
    tabs: ["overview", "services", "users", "numbers", "devices", "routing"],
  },
  {
    title: "Calling and messages",
    tabs: ["features", "voicemail", "recordings", "experiences"],
  },
  { title: "Account", tabs: ["billing", "orders"] },
];
const labels: Record<AccountTab, string> = {
  overview: "Overview",
  services: "Services",
  users: "Extensions",
  numbers: "Numbers",
  devices: "Equipment",
  routing: "Routing",
  features: "Features",
  voicemail: "Voicemail",
  recordings: "Recordings",
  experiences: "Add-ons",
  billing: "Billing",
  orders: "Orders",
};

export function AccountNavigation({
  tabs,
  selected,
  commercial,
  onTab,
  additionalTabs = [],
}: {
  tabs: readonly AccountTab[];
  selected: AccountTab;
  commercial: boolean;
  onTab: (tab: AccountTab) => void;
  additionalTabs?: readonly AccountTab[];
}) {
  return (
    <nav className="cr-account-navigation" aria-label="Account sections">
      {groups.map((group) => {
        const available = group.tabs.filter((tab) => tabs.includes(tab));
        if (!available.length) return null;
        return (
          <div className="cr-account-navigation-group" key={group.title}>
            {tabs.length > 2 && <p>{group.title}</p>}
            <div className="cr-tabs">
              {available.map((tab) => (
                <button
                  key={tab}
                  className={selected === tab ? "selected" : ""}
                  aria-pressed={selected === tab}
                  onClick={() => onTab(tab)}
                >
                  {tab === "users" && !commercial
                    ? "Users & lines"
                    : labels[tab]}
                </button>
              ))}
            </div>
          </div>
        );
      })}
      {additionalTabs.length > 0 && (
        <details
          className="cr-account-more"
          open={additionalTabs.includes(selected) || undefined}
        >
          <summary>More service details</summary>
          <div className="cr-tabs" aria-label="Additional account sections">
            {additionalTabs.map((tab) => (
              <button
                key={tab}
                className={selected === tab ? "selected" : ""}
                aria-pressed={selected === tab}
                onClick={() => onTab(tab)}
              >
                {tab === "users" && !commercial ? "Users & lines" : labels[tab]}
              </button>
            ))}
          </div>
        </details>
      )}
    </nav>
  );
}
